export default {
  title: 'Test restaurants',
  description:
    'Each partner may mark one restaurant as its test restaurant. It works like any other restaurant and is never billed. A Slack alert goes out when its sales for the month pass the threshold.',
  empty: 'No partner has a test restaurant.',
  columns: {
    partner: 'Partner',
    restaurant: 'Restaurant',
    designated: 'Marked as test',
    gmv: 'GMV this month',
  },
  statuses: {
    live: 'Live',
    paused: 'Offline',
    suspended: 'Suspended',
  },
  gmv: {
    converted: '≈ {{amount}}',
    no_rate: 'No exchange rate stored',
  },
  actions: {
    remove: 'Remove Test designation',
  },
  toasts: {
    load_error: 'The test restaurants could not be loaded.',
  },
};
